import React, { useState, useEffect } from 'react';
import { X, Heart, Plus, Phone, Mail, Globe, Info, Briefcase, GalleryThumbnails, Scissors, Shirt, MapPin, Tag, ChevronRight } from 'lucide-react';
import { createPortal } from 'react-dom';
import userService from '../services/UserService';
import { User } from './UserModal';
import { ProfileDetailPopup } from './ProfileDetailPopup';
import { SbCurrentUser } from '../submission_boards/component/SbModel';

interface ProfileDetailViewProps {
  user?: User;
  currentUser?: SbCurrentUser;
  userUuid?: string;
  project_id?: string;
  project_folder_id?: string;
  link_from?:string;
  sb_id?:string;
  backUrl?: string;
  onClose?: () => void;
}


export const ProfileDetailView: React.FC<ProfileDetailViewProps > = ({ user, currentUser, backUrl,userUuid,project_id, project_folder_id,
  sb_id, link_from,
   onClose}) => {
  const handleClose = () => {
    if (backUrl) {
      window.location.href = backUrl;
    }
    if(onClose) {
        onClose();
    }
    //  else {
    //   window.history.back();
    // }
  };

  return <ProfileDetailPopup user={user} 
    currentUser={currentUser}
    userUuid={userUuid} 
      project_id={project_id} 
      project_folder_id={project_folder_id}
        sb_id ={sb_id}
        link_from={link_from}
  onClose={handleClose} />;
};
